import { useQuasar } from "quasar";
import { CURRENCY } from "src/assets/scripts/utilities/constants";
import PConfirmDialog from "src/components/PConfirmDialog.vue";
import PDialogForm from "src/components/PDialogForm.vue";
import { usePaymentsStore } from "src/stores/payments";

export function useReject({ closeForm, formData }) {
  const $q = useQuasar();

  const loading = ref(false);

  const { rejectPaymentRequest } = usePaymentsStore();

  const onConfirm = async (reason, confirmDialog, doubleConfirmationDialog) => {
    try {
      loading.value = true;

      const payload = {
        _id: unref(formData)._id,
        reason: unref(reason),
        source: unref(formData).source,
      };

      doubleConfirmationDialog?.hide();

      confirmDialog?.hide();

      await rejectPaymentRequest(payload);

      closeForm();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const doubleConfirmationHandler = (reason, confirmDialog) => {
    try {
      const doubleConfirmationDialog = $q.dialog({
        component: PConfirmDialog,
        componentProps: {
          labelClass: "text-center q-ma-xl rounded-borders",
          label: "Final Rejection confirmation ?",
          onConfirm: () =>
            onConfirm(reason, confirmDialog, doubleConfirmationDialog),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmReject = () => {
    const confirmDialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: `Reject payment request ${unref(formData).internal_number}`,
        submitLabel: "Reject",
        cancellable: false,
        loading: loading,
        text: `Are you sure you want to reject this payment request of  ${
          CURRENCY.symbol
        } ${unref(formData).net_payable} to ${
          unref(formData)?.seller?.shop_name
        } ?`,
        textClass: "text-md text-neutral text-weight-bold text-color-red",
        form: {
          input: {
            required: true,
            type: "textarea",
            autogrow: true,
            placeholder: "Enter Reason",
            label: "Additional remarks",
            labelClasses: "text-sm text-neutral text-weight-bold",
            help: "Add reason for rejection",
            helpClasses: "text-sm text-neutral-70 q-mt-none",
          },
        },
        onConfirm: (reason) => {
          doubleConfirmationHandler(reason, confirmDialog);
        },
      },
    });
  };

  const rejectButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Reject",
      type: "button",
      onClick: confirmReject,
    };
  });

  return {
    rejectButton,
  };
}
